import { convertStringTime } from "utils/utils";
import { apiMain } from "./apiMain";
import { TrueIDResponse, UserDataEKYC, UserProfileEKYC } from "utils/ekycType";

export const convertDaTaCCCD = async (
  cardInfo: TrueIDResponse,
): Promise<UserDataEKYC> => {
  const { editOCR, decision, rawImage, idInfo } = cardInfo;

  const listCountry = await apiMain.getCountry();
  const country = listCountry.data.find((a: any) => a?.id == "234");
  const listProvince = await apiMain.getProvince({
    countryId: 234,
  });
  const province = listProvince.data.find((a: any) =>
    a.administrativeCode == idInfo?.id_address_province?.code
      ? idInfo?.id_address_province?.code
      : 0,
  );
  const listDistrict = await apiMain.getDistrict({
    provinceId: province?.id || 0,
  });
  const district = listDistrict.data.find((a: any) =>
    a.administrativeCode == idInfo?.id_address_district?.code
      ? idInfo?.id_address_district?.code
      : 0,
  );
  const listWard = await apiMain.getWard({
    districtId: district?.id || 0,
  });
  const ward = listWard.data.find((a: any) =>
    a.administrativeCode == idInfo?.id_address_ward?.code
      ? idInfo?.id_address_ward?.code
      : 0,
  );
  const userProfile: UserProfileEKYC = {
    gender: editOCR?.gender == "MALE" ? 1 : 0,
    dob: convertStringTime(editOCR?.dateOfBirth || ""),
    nationalityId: 234,
    idTypeId: 1,
    idNo: editOCR?.idNumber,
    dateOfIssue: convertStringTime(editOCR?.givenDate || ""),
    placeOfIssue: editOCR?.placeOfIssue,
  };
  const userAddress = {
    permanentAddress: idInfo?.id_address?.value || "",
    countryId: 234,
    provinceId: province?.id || 0,
    districtId: district?.id || 0,
    wardId: ward?.id || 0,
    //
    mailingAddress: idInfo?.id_address?.value || "",
    mailingCountryId: 234,
    mailingProvinceId: province?.id || 0,
    mailingDistrictId: district?.id || 0,
    mailingWardId: ward?.id || 0,
    country,
    province,
    district,
    ward,
  };
  return {
    userProfile,
    userAddress,
    isKYC: decision?.code == 1,
    name: editOCR?.fullName,
    person: editOCR,
    backCardImage: rawImage?.back,
    frontCardImage: rawImage?.front,
    cardInfo,
  };
};
